import _ from 'lodash';

Mobi2Go._class = Mobi2Go._class || {};

const { Price } = Mobi2Go._class.Common;

/**-----------------------------------------------------------------------------
 * Represents HeadOffice\Order\Products
 * Collection of OrderProducts contained in an Order
 * @todo Rewrite as Collection?
 */

Mobi2Go._class.OrderProducts = function(order_events) {
    /*--------------------------------------------------------------------------
     * Events
     * Inherits parent Order object's events
     */
    const { bind } = order_events;
    const { trigger } = order_events;
    const unbind = order_events.trigger;
    const { once } = order_events;

    /**-------------------------------------------------------------------------
     * Properties
     */
    let collection = [];
    let total = new Price(0.0);
    let quantity = 0;

    /**-------------------------------------------------------------------------
     * Menu Tier updating
     */
    bind('updateMenuTierId', recalculateTotal);

    /**
     * Menu Level updating
     */
    bind('updateMenuLevelId', recalculateTotal);

    /**-------------------------------------------------------------------------
     */
    function recalculateTotal() {
        _.invokeMap(collection, 'updateModifierPrices');
        _.invokeMap(collection, 'calculateTotal');
        updateTotal();
    }

    /**-------------------------------------------------------------------------
     */
    function updateTax() {
        _.each(collection, function(product) {
            product.updateTax();
        });
    }

    /**-------------------------------------------------------------------------
     */
    function getSalesTaxTotal() {
        return _.reduce(
            collection,
            function(total, product) {
                return total.add(product.total.getTaxPrice());
            },
            new Price(0.0)
        );
    }

    /**-------------------------------------------------------------------------
     */
    function getTotal() {
        return _.reduce(
            collection,
            function(total, product) {
                return total.add(product.total);
            },
            new Price(0.0)
        );
    }

    /**-------------------------------------------------------------------------
     */
    function updateTotal() {
        const new_total = getTotal();
        if (new_total.isEqual(total)) {
            return;
        }
        total = new_total;
        trigger('updateProductsTotal', total);
    }

    /**-------------------------------------------------------------------------
     */
    function getQuantity() {
        return _.reduce(
            collection,
            function(quantity, product) {
                return quantity + product.quantity;
            },
            0
        );
    }

    /**-------------------------------------------------------------------------
     */
    function updateQuantity() {
        const new_quantity = getQuantity();
        if (new_quantity === quantity) {
            return;
        }
        quantity = new_quantity;
        trigger('updateProductsQuantity', quantity);
    }

    /**-------------------------------------------------------------------------
     */
    function updateProductModifierSelection(modifier) {
        trigger('updateProductModifierSelection', modifier);
    }

    function updateProductModifierQuantity(modifier) {
        trigger('updateProductModifierQuantity', modifier);
    }

    function updateProductMetadata() {
        trigger('updateProductMetadata');
    }

    /**-------------------------------------------------------------------------
     */
    function set(products) {
        _.each(products, function(product, index) {
            if (collection[index]) {
                collection[index].set(product);
            } else {
                product = Mobi2Go._class.OrderProduct(product);
                add(product, true);
            }
        });

        // Remove stragglers
        if (products.length < collection.length) {
            const products_to_remove = _.slice(collection, products.length);

            _.each(products_to_remove, product => {
                remove(product, true);
            });
        }

        updateQuantity();
        updateTotal();
    }

    /**-------------------------------------------------------------------------
     */
    function add(product, skip_collection_update) {
        if (!(product instanceof Mobi2Go._class.OrderProduct)) {
            if (!(product instanceof Mobi2Go._class.MenuItem.Product)) {
                throw new TypeError(
                    'Mobi2Go._class.OrderProduct or Mobi2Go._class.MenuItem.Product required'
                );
            }

            product = product.createOrderProductInstance();
        }

        const last_added_product = _.last(collection);

        if (
            last_added_product &&
            last_added_product.getSignature() === product.getSignature()
        ) {
            last_added_product.setQuantity(
                last_added_product.quantity + product.quantity
            );

            if (!skip_collection_update) {
                updateQuantity();
                updateTotal();
            }

            return;
        }

        collection.push(product);
        trigger('addProduct', product);
        product.trigger('addToOrder');

        product.bind({
            updateTotal,
            updateQuantity,
            updateModifierSelection: updateProductModifierSelection,
            updateModifierQuantity: updateProductModifierQuantity,
            updateMetadata: updateProductMetadata,
        });

        if (!skip_collection_update) {
            updateQuantity();
            updateTotal();
        }
        return product;
    }

    /**-------------------------------------------------------------------------
     */
    function remove(product, skip_collection_update) {
        if (!product instanceof Mobi2Go._class.OrderProduct) {
            throw new TypeError('Mobi2Go._class.OrderProduct required');
        }

        const o_length = collection.length;
        collection = _.reject(collection, {
            cid: product.cid,
        });

        if (o_length === collection.length) {
            return;
        }

        trigger('removeProduct', product);
        product.trigger('removeFromOrder');

        product.unbind({
            updateTotal,
            updateQuantity,
            updateModifierSelection: updateProductModifierSelection,
            updateModifierQuantity: updateProductModifierQuantity,
            updateMetadata: updateProductMetadata,
        });

        if (!skip_collection_update) {
            updateQuantity();
            updateTotal();
        }
    }

    /**-------------------------------------------------------------------------
     * Public methods
     */
    return {
        get() {
            return collection;
        },
        getTotal,
        getSalesTaxTotal,
        updateTax,
        getQuantity,
        set,
        add,
        remove,
        contains(product) {
            return _.includes(_.map(collection, 'cid'), product.cid);
        },
        toJson() {
            return _.invokeMap(collection, 'toJson');
        },

        bind,
        once,
        unbind,
    };
};
